import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    container: {
      // padding: theme.spacing(3),
    },
    header: {
      marginBottom: 52,
    },
    sectionTitle: {
      fontSize: '16px',
      fontWeight: 400,
      color: STYLE.COLOR.TEXT1,
      lineHeight: '24px',
      margin: '0px 0px 16px 0px',
    },
    requiredMark: {
      color: STYLE.COLOR.ERROR,
      paddingLeft: '3px',
    },
    nextButton: {
      minWidth: '222px !important',
    },
    addTradeButton: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(3),
    },
    plusIcon: {
      marginRight: theme.spacing(1),
      fontSize: '16px',
    },
    fieldName: {
      fontSize: '14px',
      fontWeight: 500,
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(1),
    },
    divider: {
      marginTop: '36px !important',
      marginBottom: '22px !important',
    },
  }),
);
